import React, {ReactElement} from "react";
// import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import App from "./App";
import makeStore from "./services/store";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import { createRoot } from 'react-dom/client';


// if (false) {
//     Sentry.init({
//         dsn: "https://50c6f7586ecc40ea94d7c140e28ace33@o1148506.ingest.sentry.io/6219975",
//         integrations: [new BrowserTracing()],
//
//         // Set tracesSampleRate to 1.0 to capture 100%
//         // of transactions for performance monitoring.
//         // We recommend adjusting this value in production
//         tracesSampleRate: 1.0,
//     });
// } else {
//     console.error("No error tracking attached!");
// }
const store = makeStore();

const WithProvider = (): ReactElement => {

    return (
        <GoogleReCaptchaProvider
            useRecaptchaNet
            reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY as string}
            scriptProps={{async: true, defer: true, appendTo: 'body'}}
        >
            <Provider store={store}>
                    <App/>
            </Provider>
        </GoogleReCaptchaProvider>
    );
}

const container = document.getElementById('root');
const root = createRoot(container as Element);
root.render(<WithProvider />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
